import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { withRouter } from 'react-router';
import swal from 'sweetalert';
import { startCase } from 'lodash';

const propTypes = {
  device: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
};

class DeviceItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: false,
    };
  }

  toggle = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  delete = (e) => {
    this.toggle(e);

    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this device!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        const { onDelete, device: { id } } = this.props;
        onDelete(id);
      }
    });
  }

  renderLabel(label) {
    if (!label) { return null; }
    return <small>({label})&nbsp;</small>;
  }

  render() {
    const { match, device } = this.props;

    return (
      <li
        className="DeviceItem"
      >
        <Link
          to={`${match.url}/${device.id}/edit`}
          className="DeviceItem__link"
        >
          <div className="DeviceItem__link__details">
            <div className="device-info">
              <div className="device-name">
                {this.renderLabel(device.deviceable.label)}
                {device.manufacturer}
              </div>
              <div className="device-serial-number">
                <span className="device-type">{startCase(device.deviceable.type)}</span> / {device.deviceable.serial_number}
              </div>
            </div>
          </div>
          <div className="DeviceItem__link__actions">
            <Dropdown isOpen={this.state.dropdownOpen} toggle={(e) => this.toggle(e)}>
              <DropdownToggle
                tag="span"
                onClick={(e) => this.toggle(e)}
                className="more"
                data-toggle="dropdown"
                aria-expanded={this.state.dropdownOpen}
              >
                <FontAwesomeIcon icon={["fal", "ellipsis-v-alt"]} />
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem
                  onClick={(e) => this.delete(e)}
                >Delete</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </Link>
      </li>
    );
  }
}

DeviceItem.propTypes = propTypes;

export default withRouter(DeviceItem);



// WEBPACK FOOTER //
// ./src/features/device/DeviceListContainer/DeviceList/DeviceItem.js